'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import * as Styled from './friends-empty.styled';
export const FriendsEmpty = React.memo(function FriendsEmpty() {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  return <Styled.Wrapper>
      <Styled.Image />
      <Styled.Title>{profileModel.strings.friendsTitle}</Styled.Title>
      <Styled.Description>{profileModel.strings.friendsDescription}</Styled.Description>
      {profileModel.links.friendsDownloadLink ? <Styled.DownloadLink href={profileModel.links.friendsDownloadLink} {...buildQaTrackingEntityProps('newProfile.friends.downloadLink')}>
          {profileModel.strings.friendsDownloadLinkText}
        </Styled.DownloadLink> : null}
    </Styled.Wrapper>;
});